import React from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import { ArrowRight } from "@phosphor-icons/react";
import Seo from "@/components/Seo";

const steps = [
  { num: "01", title: "You reach out", desc: "A short message is enough. Tell us who you are and roughly what you're thinking about." },
  { num: "02", title: "We have a discovery call", desc: "30–45 minutes with the right people from your school. We listen more than we talk." },
  { num: "03", title: "We share a tailored outline", desc: "A personalised plan for your school community, audience, and calendar." },
];

export default function Schools() {
  return (
    <Page>
      <Seo title="For Schools & Institutions" description="Psychology career, cognitive health and wellbeing programmes for schools, colleges and universities." />
      <section className="md-section md-page-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4">School Partnerships</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif">
            Your school already has a <em>cognitive health</em> challenge.
            <br className="hidden md:block" /> Let&apos;s address it together.
          </h1>
          <p className="text-base mt-5 max-w-3xl mx-auto">
            We partner with schools to help students, teachers, and parents understand how the brain works, and how to look after it in a world that moves too fast.
          </p>
          <div className="flex mt-8">
            <Link to="/contact?source=schools-hero" className="btn-primary" data-testid="schools-hero-cta">
              Let&apos;s start with a conversation <ArrowRight size={14} weight="bold" />
            </Link>
          </div>
        </div>
      </section>

      <section className="md-section">
        <div className="md-container">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <p className="text-base" style={{ color: "var(--md-text-soft)" }} data-testid="schools-intro-1">
              We know every school is different. Before anything else, we&apos;d like to understand your context, what&apos;s already working, where the gaps are, and which part of the community needs the most support right now. From there, we design something that actually fits.
            </p>
            <p className="text-base mt-4" style={{ color: "var(--md-text-soft)" }} data-testid="schools-intro-2">
              We also run career workshops for students curious about psychology, so the young people who connect most with this work have somewhere to take that interest next.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {steps.map((s) => (
              <div key={s.num} className="md-card">
                <div className="wordmark text-4xl" style={{ color: "var(--md-accent)" }}>{s.num}</div>
                <h3 className="text-2xl font-serif mt-4">{s.title}</h3>
                <p className="mt-3 text-sm" style={{ color: "var(--md-text-soft)" }}>{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link to="/contact?source=schools-enquire" className="btn-primary" data-testid="schools-enquire">Start the conversation <ArrowRight size={14} weight="bold" /></Link>
          </div>
        </div>
      </section>
    </Page>
  );
}
